module.exports = __webpack_public_path__ + "static/sc-02-425336ec2bc494f73fd015976ac139ea.png";